import React, { useState } from 'react';
import { Button, Drawer } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EditConfigurationServiceForm from './EditConfigurationServiceForm';
import { ProxyCredential } from 'src/types/ProxyServiceInfo';
import { useProxyDetailsUpadate } from 'src/api/proxyService';
import styles from './EditConfigurationServiceModal.module.less';

type EditConfigurationServiceModalProps = {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  proxyService: ProxyCredential | null;
  onUpdate: () => void;
  onEdit: (values: ProxyCredential | null) => void;
};

const EditConfigurationServiceModal: React.FC<EditConfigurationServiceModalProps> = ({
  visible,
  setVisible,
  proxyService,
  onUpdate,
  onEdit,
}) => {
  const [editedProxyUser, setEditedProxyUser] = useState<ProxyCredential | null>(null);
  useProxyDetailsUpadate(editedProxyUser, onUpdate);
  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
    onEdit(null);
  };

  const onEditProxyUser = (values: ProxyCredential | null) => {
    setEditedProxyUser(values);
    onClose();
  };

  return (
    <Drawer
      placement="bottom"
      closable={false}
      onClose={onClose}
      visible={visible}
      height={'100%'}
      className={styles.createNewServiceDrawer}
    >
      <Button onClick={onClose} className={styles.closeButton} type="link">
        <FontAwesomeIcon onClick={showDrawer} icon={['fal', 'times']} className={styles.closeIcon} size={'3x'} />
      </Button>

      {visible && (
        <EditConfigurationServiceForm onSave={onEditProxyUser} proxyId={proxyService ? proxyService.proxyId : 0} />
      )}
    </Drawer>
  );
};

export default EditConfigurationServiceModal;
